import React, { useEffect, useState } from 'react'
import MySelect from '../../UI/form/MySelect'
import { responseError } from '../../../helpers/response/ResponseHelper'
import { getDepartmentTypesAllAPI } from '../../../api/department/departmentTypeAPI'

const DepartmentTypeSelectMain = ({ required, setValidate, setValueForm, forciblyValue }) => {

  	const [value, setValue] = useState(forciblyValue)
	const [departmentTypes, setDepartmentTypes] = useState([])

	useEffect(() => {
		getDepartmentTypes()
	}, [])

	useEffect(() => {
		valid()
	}, [required, value])

	const getDepartmentTypes = () => {
		getDepartmentTypesAllAPI().then(data => {
			setDepartmentTypes(data)
		}).catch(e => {
			// setError(responseError(e))
			console.error(responseError(e))
		})
	}

	const valid = () => {
		if (required) {
			if (value) {
				setValidate(true)
			} else {
				setValidate(false)
			}
		} else {
			setValidate(true)
		}
	}

  return (
    <MySelect
        value={value}
        label="Тип підрозділу"
        labelId="select__departmentType-label"
        id='select__departmentType'
        onChange = {e => {
			setValueForm(e)
            setValue(e)
			// setEvent({...event, categoryId: e})
		}}
        nameField='Тип підрозділу'
        // sx={{width: '200px'}}
        options={
			departmentTypes && departmentTypes.length > 0 ? 
				departmentTypes.map(departmentType => {
            		return {id: departmentType.id, name: departmentType.name}
				})
			: []	
		}
        // options={[]}
    />
  )
}

export default DepartmentTypeSelectMain